'use strict';

import Model from '../Model';

export default class Market extends Model {

    static defaultConnection() {
        return 'markets';
    }

    static fields() {
        return `id, name`;
    }
}


// WEBPACK FOOTER //
// ./src/graphql/model/Market.js